// extracted by mini-css-extract-plugin
export default {"description":"cxb4jhcTNsFHhDW19uO6"};